import { NotificationStatus } from '../../types';
import { NotificationTabProps } from './types';

export const config: NotificationTabProps[] = [
  {
    key: `${NotificationStatus.SENT},${NotificationStatus.DELIVERED},${NotificationStatus.ARCHIVED}`,
    label: 'All',
    value: NotificationStatus.ALL,
  },
  {
    key: NotificationStatus.SENT,
    label: 'New',
    value: NotificationStatus.SENT,
  },
];
